import services from '@/api/services';
import StoreConstructor from '@/store/core/StoreConstructor';
import { action, observable, computed } from 'mobx';

export default class ExternalPaymentInfoStore extends StoreConstructor {
  @observable isFetching = false;
  @observable data: Record<any, any> | null = null;
  @observable error: string | null = null;

  @computed get procesedData() {
    if (!this.data?.documents?.[0]) return null;
    const data = {
      ...this.data?.documents?.[0],
      amount: this.data?.documents?.reduce((acc: any, i: any) => i.amount + acc, 0),
      registry: this.data?.documents?.reduce(
        (acc: any, i: any) => acc.concat(i.registry),
        [],
      ),
    };
    return data;
  }

  @action async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.external.GetPePaymentDocumentsRequest();
      this.data = data;
    } catch (e: any) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action async sendPayment(body: any) {
    this.isFetching = true;
    try {
      const { data } = await services.external.PostPePaymentInfoRequest(body);
      this.data = data;
      return 'ok';
    } catch (e: any) {
      this.error = e.response.data.errors
        .map((err: any) => err.message)
        .join('\n');
      console.error(e);
      return 'err';
    } finally {
      this.isFetching = false;
    }
  }

  @action reset() {
    this.data = null;
  }
}
